import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeModeProvider } from './context/ThemeModeContext';
import { NotificationProvider } from './context/NotificationContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { QueryProvider } from './providers/QueryProvider';
import { BASELINE_SOFTWARE_VERSION } from './constants/version';

const MINIMUM_LAUNCH_SCREEN_MS = 900;

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

const setLaunchScreenVersion = (baselineVersion: string) => {
  const versionElement = document.getElementById('launch-screen-version');
  if (versionElement) {
    versionElement.textContent = `Current Baseline Version: ${baselineVersion}`;
  }
};

setLaunchScreenVersion(BASELINE_SOFTWARE_VERSION);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeModeProvider>
          <NotificationProvider>
            <QueryProvider>
              <WebSocketProvider>
                <App />
              </WebSocketProvider>
            </QueryProvider>
          </NotificationProvider>
        </ThemeModeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
};

const startApplication = async () => {
  const launchDelayPromise = new Promise<void>((resolve) => {
    window.setTimeout(resolve, MINIMUM_LAUNCH_SCREEN_MS);
  });

  await launchDelayPromise;
  renderApp();
};

void startApplication();